<template lang="pug">
v-expansion-panel.elevation-0(v-model='expanded', expand)
  v-expansion-panel-content
    template(slot='header')
      span(v-if='data.companyName') Gegevens bij lopende lening van <b>{{ data.companyName }}</b>
      span(v-else) Nieuwe lopende lening
    .pa-4
      text-field.mr-0(
        label='Naam maatschappij',
        v-model='data.companyName'
        :error-messages='companyNameValidationErrors',
        @change='$v.data.companyName.$touch()',
        @blur='$v.data.companyName.$touch()',
        required
        )

      text-field.mr-0(
        label='Contractnummer',
        v-model='data.contractNumber'
        :error-messages='contractNumberValidationErrors',
        @change='$v.data.contractNumber.$touch()',
        @blur='$v.data.contractNumber.$touch()',
        required
        )

      euro-field.mr-0(
        label='Bruto hoofdsom',
        v-model.number='data.loanTotalGross'
        :error-messages='loanTotalGrossValidationErrors',
        @change='$v.data.loanTotalGross.$touch()',
        @blur='$v.data.loanTotalGross.$touch()',
        required,
        )

      euro-field.mr-0(
        label='Nog in the lossen bedrag',
        v-model.number='data.loanAmountRemaining'
        :error-messages='loanAmountRemainingValidationErrors',
        @change='$v.data.loanAmountRemaining.$touch()',
        @blur='$v.data.loanAmountRemaining.$touch()',
        type='number',
        required,
        )

      euro-field.mr-0(
        label='Werkelijke last per maand',
        v-model.number='data.chargesMonthly'
        :error-messages='chargesMonthlyValidationErrors',
        @change='$v.data.chargesMonthly.$touch()',
        @blur='$v.data.chargesMonthly.$touch()',
        type='number',
        required,
        )

      text-field.mr-0(
        label='Huidig rentepercentage',
        v-model.number='data.ratePercentage'
        type='number',
        min='0',
        step='1',
        :error-messages='ratePercentageValidationErrors',
        @change='$v.data.ratePercentage.$touch()',
        @blur='$v.data.ratePercentage.$touch()',
        required,
        prefix='%'
        )

      v-layout(column)
        label: b Wil je deze lening oversluiten?*
        v-select(
          :items='yesNoItems',
          v-model='data.consolidateLoan'
          :error-messages='consolidateLoanValidationErrors',
          @change='$v.data.consolidateLoan.$touch()',
          @blur='$v.data.consolidateLoan.$touch()',
          required,
          solo
          )
</template>

<script>
// import { required, decimal } from 'vuelidate/lib/validators'
import required from 'vuelidate/src/validators/required'
import decimal from 'vuelidate/src/validators/decimal'
import { yesNoDropdownItems } from '../helpers/template'

export default {
  name: 'Loan',

  props: {
    loanIndex: Number,
    loan: Object
  },

  data () {
    return {
      yesNoItems: yesNoDropdownItems,

      data: this.loan,

      expanded: [false]
    }
  },

  computed: {
    companyNameValidationErrors () {
      const errors = []
      if (!this.$v.data.companyName.$dirty) return errors
      !this.$v.data.companyName.required && errors.push('Dit veld is verplicht')
      return errors
    },

    contractNumberValidationErrors () {
      const errors = []
      if (!this.$v.data.contractNumber.$dirty) return errors
      !this.$v.data.contractNumber.required && errors.push('Dit veld is verplicht')
      return errors
    },

    loanTotalGrossValidationErrors () {
      const errors = []
      if (!this.$v.data.loanTotalGross.$dirty) return errors
      !this.$v.data.loanTotalGross.decimal && errors.push('Dit moet een getal zijn')
      !this.$v.data.loanTotalGross.required && errors.push('Dit veld is verplicht')
      return errors
    },

    loanAmountRemainingValidationErrors () {
      const errors = []
      if (!this.$v.data.loanAmountRemaining.$dirty) return errors
      !this.$v.data.loanAmountRemaining.decimal && errors.push('Dit moet een getal zijn')
      !this.$v.data.loanAmountRemaining.required && errors.push('Dit veld is verplicht')
      return errors
    },

    chargesMonthlyValidationErrors () {
      const errors = []
      if (!this.$v.data.chargesMonthly.$dirty) return errors
      !this.$v.data.chargesMonthly.decimal && errors.push('Dit moet een getal zijn')
      !this.$v.data.chargesMonthly.required && errors.push('Dit veld is verplicht')
      return errors
    },

    ratePercentageValidationErrors () {
      const errors = []
      if (!this.$v.data.ratePercentage.$dirty) return errors
      !this.$v.data.ratePercentage.decimal && errors.push('Dit moet een getal zijn')
      !this.$v.data.ratePercentage.required && errors.push('Dit veld is verplicht')
      return errors
    },

    consolidateLoanValidationErrors () {
      const errors = []
      if (!this.$v.data.consolidateLoan.$dirty) return errors
      !this.$v.data.consolidateLoan.required && errors.push('Dit veld is verplicht')
      return errors
    }
  },

  validations: {
    data: {
      companyName: {
        required
      },

      contractNumber: {
        required
      },

      loanTotalGross: {
        required,
        decimal
      },

      loanAmountRemaining: {
        required,
        decimal
      },

      chargesMonthly: {
        required,
        decimal
      },

      ratePercentage: {
        required,
        decimal
      },

      consolidateLoan: {
        required
      }
    }
  },

  methods: {
    emitValid () {
      this.$emit('setValid', {
        loanIndex: this.loanIndex,
        valid: !this.$v.$invalid
      })
    }
  },

  created () {
    this.emitValid()
  },

  watch: {
    data: {
      handler: function (v) {
        this.$emit('setLoan', {
          loanIndex: this.loanIndex,
          loan: this.data
        })
      },
      deep: true
    },

    '$v.$invalid': {
      handler: function (v) {
        this.emitValid()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
